import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getWheelEntity, getWheelEntityThemes, patchWheelEntity, postWheelEntity } from "./thunks";
import { FortuneWheelEntity } from "../../../entities/wheelGame_v2";

interface FortuneWheelProfileState {
  loading: boolean,
  saveLoading: boolean,
  entity?: FortuneWheelEntity,
  themes: string[]
}

const initialState: FortuneWheelProfileState = {
  loading: false,
  saveLoading: false,
  themes: [],
}

const saveFortuneWheel = (
  builder: ActionReducerMapBuilder<FortuneWheelProfileState>,
  action: any
) => {
  builder.addCase(action.pending, (state: FortuneWheelProfileState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: FortuneWheelProfileState, action: PayloadAction<FortuneWheelEntity>) => {
    state.saveLoading = false;
    state.entity = action.payload;
  });
  builder.addCase(action.rejected, (state: FortuneWheelProfileState) => {
    state.saveLoading = false;
  });
};

export const fortuneWheelEntityStore = createSlice({
  name: "fortuneWheelEntity",
  initialState: initialState,
  reducers: {
    clearEntity: (state) => {
      state.entity = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getWheelEntity.pending, state => {
      state.loading = true;
    })
    builder.addCase(getWheelEntity.fulfilled, (state, action) => {
      state.entity = action.payload;

      state.loading = false;
    })
    // getWheelEntityThemes
    builder.addCase(getWheelEntityThemes.pending, (state) => {

    })
    builder.addCase(getWheelEntityThemes.fulfilled, (state, action) => {
      state.themes = action.payload;
    })
    const saveActions = [patchWheelEntity,
      postWheelEntity];

    saveActions.forEach((action) => { saveFortuneWheel(builder, action) })
  },
})

export const { clearEntity } = fortuneWheelEntityStore.actions

export default fortuneWheelEntityStore.reducer